interface RouterParams {
  idDocument?: string;
  [key: string]: string | undefined;
}

type BreadcrumbFunction = (params: RouterParams) => string;

export interface BreadcrumbNameMap {
  [key: string]: string | BreadcrumbFunction;
}

export const breadcrumbNameElectronicDocumentsMap: BreadcrumbNameMap = {
  "/consulta_documentos_electronicos": "Consulta Documentos Electrónicos",
  "/consulta_documentos_electronicos/detalle_documento/:value":
    "Detalle Documento",
  "/consulta_documentos_electronicos/detalle_documento/:value/auditar_glosas":
    "Auditar Glosas",
  "/consulta_documentos_electronicos/detalle_documento/:value/ver_detalle_contrato/:value2":
    "Ver Detalle Contrato",
  "/consulta_documentos_electronicos/radicar_facturas/:vale":
    "Radicar Facturas",
  "/reportes": "Reportes",
  "/reportes/:value": "Visualizar Reporte",
  "/autorizaciones": "Facturas candidatas para pagos",
  "/autorizaciones/paquetes-exportados":
    "Paquetes facturas exportados para pago",
  "/autorizaciones/paquetes-exportados/:packageId": "Detalle paquete",
  "/autorizaciones/resumen-proceso-pago": "Resumen de exporte para pagos",
  "/autorizaciones/gestion-deducciones": "Gestión de deducciones",
  "/autorizaciones/administrar-centro-costo":
    "Administración de centros de costo",
  "/autorizaciones/detalle_documento/:value": "Detalle Documento",
  "/contratos": "Contratos",
  "/consulta_documentos_electronicos/cargar_soportes_pagos":
    "Carga Masiva Soportes De Pago",
  "/gestion-usuarios-prestadores": "Gestión de Usuarios Prestadores",
  "/gestion-usuarios": "Gestión de Usuarios",
};
